var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                "label-col": _vm.labelCol2,
                "wrapper-col": _vm.wrapperCol2,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.seatgroup.sgroupcode"],
                            prop: "sgroupcode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "common.autosystemcode"
                              ],
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.sgroupcode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sgroupcode", $$v)
                              },
                              expression: "model.sgroupcode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.seatgroup.sgroupname"],
                            prop: "sgroupname"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "cs.seatgroup.sgroupname"
                              ],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.sgroupname,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sgroupname", $$v)
                              },
                              expression: "model.sgroupname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShow,
                          expression: "isShow"
                        }
                      ],
                      attrs: { span: 12 }
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.activityname"],
                            prop: "sysactivityid"
                          }
                        },
                        [
                          _c("a-Select", {
                            attrs: {
                              options: _vm.selectActivityList,
                              "allow-clear": "",
                              "show-search": "",
                              optionFilterProp: "children",
                              placeholder: this.language[
                                "cs.activity.activityname"
                              ]
                            },
                            on: { change: _vm.handChangeActivity },
                            model: {
                              value: _vm.model.sysactivityid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sysactivityid", $$v)
                              },
                              expression: "model.sysactivityid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShow,
                          expression: "isShow"
                        }
                      ],
                      attrs: { span: 12 }
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.venue.venuename"],
                            prop: "sysvenueid"
                          }
                        },
                        [
                          _c("a-Select", {
                            attrs: {
                              options: _vm.selectVenueList,
                              "allow-clear": "",
                              "show-search": "",
                              optionFilterProp: "children",
                              placeholder: this.language["cs.venue.venuename"]
                            },
                            model: {
                              value: _vm.model.sysvenueid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sysvenueid", $$v)
                              },
                              expression: "model.sysvenueid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.seatgroup.sgroupcolor"],
                            prop: "sgroupcolor"
                          }
                        },
                        [
                          _c("a-space", [
                            _c("p", [
                              _vm._v("选择的颜色：" + _vm._s(_vm.color))
                            ]),
                            _c("div", {
                              style: {
                                background: _vm.color,
                                height: "20px",
                                width: "30px"
                              }
                            })
                          ]),
                          _c("sketch-picker", {
                            attrs: {
                              "preset-colors": _vm.presetColors,
                              "color-format": "hex"
                            },
                            on: { input: _vm.colorValueChange1 },
                            model: {
                              value: _vm.model.sgroupcolor,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sgroupcolor", $$v)
                              },
                              expression: "model.sgroupcolor"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }